import { render, staticRenderFns } from "./KaartComponent.vue?vue&type=template&id=cc435244&scoped=true"
import script from "./KaartComponent.vue?vue&type=script&lang=js"
export * from "./KaartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc435244",
  null
  
)

export default component.exports